import React from 'react';
import { useTranslation } from 'react-i18next';
import { Layers, Clock, GitBranch } from 'lucide-react';
import { Container, SectionHeading, GlassCard, IconBadge } from './shared';

const ICONS = [Layers, Clock, GitBranch];
const CARD_KEYS = ['toolChaos', 'tooLittleTime', 'processBottlenecks'];

const ProblemSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="relative py-24 sm:py-32">
      <Container>
        <SectionHeading
          eyebrow={t('landing.problem.eyebrow')}
          title={t('landing.problem.title')}
          subtitle={t('landing.problem.subtitle')}
        />

        <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {CARD_KEYS.map((key, i) => {
            const Icon = ICONS[i];
            return (
              <GlassCard key={key} index={i}>
                <IconBadge>
                  <Icon className="h-6 w-6 text-white" />
                </IconBadge>
                <h3 className="mb-3 text-xl font-semibold text-white">
                  {t(`landing.problem.cards.${key}.title`)}
                </h3>
                <p className="leading-relaxed text-brand-muted">
                  {t(`landing.problem.cards.${key}.description`)}
                </p>
              </GlassCard>
            );
          })}
        </div>
      </Container>
    </section>
  );
};

export default ProblemSection;
